// Friendly error overlay untuk anak usia 6-8.
// Lihat Doc 09 §10.4 untuk pattern mapping.

import { STRINGS } from '@tm/shared'

export const FRIENDLY_PATTERNS = [
  {
    pattern: /Maximum call stack/i,
    friendly: 'Program kamu mengulang terus tanpa henti. Coba tambah blok "tunggu" di dalam loop.',
  },
  {
    pattern: /is not defined/i,
    friendly: 'Ada nama yang belum dikenal. Coba cek lagi nama sprite atau variabelnya.',
  },
  {
    pattern: /TypeError.*not a function/i,
    friendly:
      'Perintah ini belum bisa dipakai di situ. Cek lagi urutan bloknya — mungkin perlu tambah "buat sprite" dulu.',
  },
  {
    pattern: /is not a function/i,
    friendly: 'Perintah ini belum bisa dipakai di situ. Cek lagi urutan bloknya.',
  },
  {
    pattern: /reading 'load'/i,
    friendly: 'Game belum siap sepenuhnya. Coba tutup lalu tekan tombol Mainkan lagi.',
  },
  {
    pattern: /Cannot read propert(y|ies)/i,
    friendly: 'Sprite ini mungkin belum dibuat. Tambah blok "buat sprite" dulu sebelum pakai.',
  },
  {
    pattern: /out of memory/i,
    friendly: 'Terlalu banyak yang dijalankan sekaligus. Coba hapus beberapa blok dulu.',
  },
  {
    pattern: /scene belum siap/i,
    friendly: 'Tambah blok "buat sprite" dulu sebelum pakai sprite.',
  },
  {
    pattern: /belum dibuat/i,
    friendly: 'Sprite ini belum dibuat. Tambah blok "buat sprite" dulu.',
  },
  {
    pattern: /Phaser.*not.*ready|scene.*not.*initialized/i,
    friendly: 'Game belum siap. Tutup area main, tunggu 2 detik, lalu tekan ▶ Mainkan lagi.',
  },
  {
    pattern: /Cannot find module|Cannot resolve/i,
    friendly: 'Ada blok yang minta gambar yang belum ada. Cek lagi menu Aset.',
  },
  {
    pattern: /SyntaxError/i,
    friendly:
      'Ada blok yang bikin kode jadi kacau. Coba hapus blok terakhir yang ditambah lalu coba lagi.',
  },
]

export function getFriendlyMessage(rawMessage) {
  for (const entry of FRIENDLY_PATTERNS) {
    if (entry.pattern.test(rawMessage)) return entry.friendly
  }
  return 'Hmm, ada yang perlu diperbaiki. Coba cek lagi blok-bloknya.'
}

let overlayEl = null

export function showError(error, container) {
  if (!container) return
  hideError()

  const friendly = error.friendlyMessage || getFriendlyMessage(error.message || '')

  overlayEl = document.createElement('div')
  overlayEl.className = 'tm-error-overlay'
  overlayEl.setAttribute('role', 'alertdialog')
  overlayEl.setAttribute('aria-modal', 'true')
  overlayEl.innerHTML = `
    <div class="tm-error-overlay__panel">
      <div class="tm-error-overlay__icon" aria-hidden="true">😅</div>
      <h3 class="tm-error-overlay__title">${STRINGS.errorOverlayTitle}</h3>
      <p class="tm-error-overlay__body">${escapeHtml(friendly)}</p>
      <button type="button" class="tm-error-overlay__btn tm-btn-primary" data-action="dismiss">
        ${STRINGS.errorOverlayDismiss}
      </button>
      ${
        error.message
          ? `
        <details class="tm-error-overlay__details">
          <summary>${STRINGS.errorOverlayDetailsLabel}</summary>
          <pre>${escapeHtml(error.message)}</pre>
        </details>
      `
          : ''
      }
    </div>
  `
  overlayEl.querySelector('[data-action="dismiss"]').addEventListener('click', () => {
    hideError()
  })
  container.appendChild(overlayEl)
  overlayEl.querySelector('button').focus()
}

export function hideError() {
  if (overlayEl && overlayEl.parentElement) {
    overlayEl.remove()
  }
  overlayEl = null
}

function escapeHtml(s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}
